<template>
    <component :is="pageModuleInstance" />
</template>

<script>
import Vue from 'vue';
import decode from 'unescape';
import { mapState, mapActions, mapMutations } from 'vuex';

const moduleName = 'StaticPageModule';

export default {
    name: moduleName,
    data() {
        return {
            additionalTags: {},
            indexedPageModules: {},
        };
    },
    props: {
        page: Number | String,
        resource: String,
        area: String,
        id: Number,
    },
    computed: {
        ...mapState('PageContent', {
            storePage: state => state.page,
            pageModules: state => state.pageModules,
            prerenderMode: state => state.prerenderMode,
        }),
        pageModuleInstance() {
            const scope = this;
            return {
                template: this.content,
                data() {
                    return {
                        displayConditions: {},
                    };
                },
                mounted() {
                    Object.keys(scope.indexedPageModules).forEach(pageModuleID => {
                        const pageModule = scope.indexedPageModules[pageModuleID];
                        if (pageModule.display_delay) {
                            setTimeout(() => {
                                Vue.set(this.displayConditions, pageModuleID, true);
                            }, pageModule.display_delay * 1000);
                        }
                    });
                    Object.keys(scope.additionalTags).forEach(pageModuleID => {
                        scope.additionalTags[pageModuleID].forEach((tag, index) => {
                            const documentElement = document.getElementById(
                                'page-module-script-' + pageModuleID + '-' + index,
                            );
                            if (documentElement) {
                                documentElement.remove();
                            }
                            const tagEl = document.createElement(tag.tag);
                            tagEl.id = 'page-module-script-' + pageModuleID + '-' + index;
                            if (tag.content) {
                                tagEl.innerHTML = tag.content;
                            }
                            if (tag.attributes && tag.attributes.hasOwnProperty('src')) {
                                tagEl.setAttribute('src', tag.attributes.src);
                            }
                            document.getElementsByTagName('body')[0].appendChild(tagEl);
                        });
                    });
                },
            };
        },
        content() {
            let content = '';
            let page;
            let fallbackPage;
            if (!this.page && !this.resource && this.area && this.storePage) {
                fallbackPage = this.storePage.id;
            }

            if (this.page && this.pageModules[this.page]) {
                page = this.pageModules[this.page];
            } else if (this.resource && this.pageModules[this.resource]) {
                page = this.pageModules[this.resource];
            } else if (fallbackPage) {
                page = this.pageModules[fallbackPage];
            }

            if (page) {
                if (this.area && page[this.area]) {
                    const area = Object.values(page[this.area]);

                    area.sort(function(a, b) {
                        return a.ordering - b.ordering || a.id - b.id;
                    });
                    const pageModules = Object.values(area);
                    for (const pageModule of pageModules) {
                        if (!this.id || pageModule.id == this.id) {
                            if (this.prerenderMode && !pageModule.display_on_prerendering) {
                                continue;
                            }
                            if (!pageModule.composite_page_module_id || this.id) {
                                this.indexedPageModules[pageModule.id] = pageModule;

                                let ifCondition = '';

                                if (pageModule.display_delay) {
                                    ifCondition += 'displayConditions[' + pageModule.id + ']';
                                }

                                if (!pageModule.display_on_desktop && !pageModule.display_on_mobile) {
                                    ifCondition += (ifCondition ? ' && ' : '') + 'false';
                                } else if (pageModule.display_on_desktop && !pageModule.display_on_mobile) {
                                    ifCondition += (ifCondition ? ' && ' : '') + '$vuetify.breakpoint.mdAndUp';
                                } else if (!pageModule.display_on_desktop && pageModule.display_on_mobile) {
                                    ifCondition += (ifCondition ? ' && ' : '') + '$vuetify.breakpoint.smAndDown';
                                }

                                if (ifCondition) {
                                    const innerDomElement = document.createElement('body');
                                    innerDomElement.innerHTML = decode(pageModule.content);
                                    Object.keys(innerDomElement.childNodes).forEach(i => {
                                        innerDomElement.childNodes[i].setAttribute('v-if', ifCondition);
                                    });
                                    content += innerDomElement.innerHTML;
                                } else {
                                    content += pageModule.content;
                                }

                                if (pageModule.additional_tags && Array.isArray(pageModule.additional_tags)) {
                                    Object.keys(pageModule.additional_tags).forEach(i => {
                                        if (!this.additionalTags[pageModule.id]) {
                                            this.additionalTags[pageModule.id] = [];
                                        }
                                        if (!this.additionalTags[pageModule.id][i]) {
                                            this.additionalTags[pageModule.id].push(pageModule.additional_tags[i]);
                                        }
                                    });
                                }
                            }
                        }
                    }
                    const domElement = document.createElement('body');
                    domElement.innerHTML = content;
                    if (domElement.childElementCount > 1) {
                        content = '<div>' + content + '</div>';
                    }
                }
            }
            if (content.length === 0) {
                content = '<div></div>';
            }
            return content;
        },
    },
};
</script>